import api from "./axios";

// Public — landing-page lead capture (no auth needed; the shared axios omits
// the Authorization header when there's no token).
export const submitLead = (payload) => api.post("/leads", payload);

// ── Super admin (management) ──────────────────────────────────────────────
export const listLeads = (params = {}) => api.get("/super/leads", { params });
export const createLead = (payload) => api.post("/super/leads", payload);
export const updateLead = (id, payload) => api.put(`/super/leads/${id}`, payload);
export const deleteLead = (id) => api.delete(`/super/leads/${id}`);
